import { render } from "./ButtonExportReport.vue?vue&type=template&id=58ae1224&lang=pug"
import script from "./ButtonExportReport.vue?vue&type=script&lang=js"
export * from "./ButtonExportReport.vue?vue&type=script&lang=js"

import "./ButtonExportReport.vue?vue&type=style&index=0&id=58ae1224&lang=scss"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__